export enum TelematicsCrewFilter {
  ALL = 'all',
  SINGLE = 'single',
  DOUBLE = 'double',
}
